import type { UpdateInfo, UpdaterManager as UpdaterManagerType } from '@rpa/shared/platform'

const { ipcRenderer } = window.electron

async function checkUpdate(): Promise<UpdateInfo> {
  return await ipcRenderer.invoke('check-for-updates')
}

async function downloadUpdate(): Promise<UpdateInfo> {
  return await ipcRenderer.invoke('download-update')
}

async function quitAndInstall() {
  ipcRenderer.send('quit-and-install-updates')
}

const UpdaterManager: UpdaterManagerType = {
  checkUpdate,
  downloadUpdate,
  quitAndInstall,
}

export default UpdaterManager
